import React from 'react'
import { Container } from 'react-bootstrap'
import './AboutUs.css'
import { Helmet } from 'react-helmet-async'
export default function AboutUs() {
  return (
    <>
      <Helmet>
        <title>درباره سازمان علمی آموزشی سه‌نیک | ترویج نیکی و آموزش‌های تخصصی</title>
        <meta
          name="description"
          content="سازمان سه‌نیک با سال‌ها تجربه و تلاش دکتر منوچهر مزداپور، ارائه‌دهنده آموزش‌های رایگان و تخصصی در زمینه مدیریت تولید و صنایع مختلف. همراه شما در مسیر پیشرفت و توسعه پایدار."
        />
      </Helmet>
      <div className='aboutus-section'>
        <Container className='aboutus-container'>
          <div className='aboutus-top'>
            <h1 className='aboutus-section-title'>درباره سه نیک</h1>
            <p>
              سازمان علمی آموزشی سه نیک، حاصل ده‌ها سال تجربه، تلاش، تحقیق و جمع آوری اطلاعات توسط آقای دکتر منوچهر مزداپور می‌باشد. هدف سه‌نیک همانطور که از نامش پیداست ترویج نیکی و کمک به یکدیگر برای رسیدن به جامعه‌ای مستقل و پویاست که در راستای این هدف خدمات و آموزش‌های ویژه‌ای را با موضوع مدیریت تولید، تولید محصولات کاربردی، صنایع بزرگ، متوسط و خرد و خانگی ارائه می‌دهد؛ که بخش بزرگی از این آموزش‌ها به صورت کاملا رایگان در اختیار شما عزیزان قرار می‌گیرد. تمامی مطالب به صورت مداوم آپدیت می‌شوند و همواره می‌توانید به بروزترین اخبار و اطلاعات صنایع گوناگون از طریق پلتفرم سه‌نیک دسترسی داشته باشید. همچنین پشتیبانی 24 ساعته در وبسایت و دیگر شبکه‌های اجتماعی وابسته به سه‌نیک، جهت راهنمایی و پاسخ به سوالات شما عزیزان در اختیارتان قرار دارد. شما عزیزان از هرنقطه‌ی این کره‌ی خاکی دعوتید تا به خانواده بزرگ سه‌نیک بپیوندید و بدون هیچ محدودیتی به ده‌ها ویدیوی آموزشی، مقاله علمی، پادکست و... دسترسی داشته باشید
            </p>
          </div>
          <div className='aboutus-bottom'>
            <h1 className='aboutus-section-title'>مدرس های سه نیک</h1>
            <p>
              آقای دکتر منوچهر مزداپور مدیر و موسس گروه آموزشی سه نیک؛
              دارای مدرک دکترای علوم سلولی و مولکولی و مدیریت DBA
              برگزار کننده همایش‌های کارآفرینی در صنعت؛
              مشاور خطوط تولید سینک و روشویی گرانیت، صفحه کورین، اسلب سنگ، انواع سنگ های مصنوعی و صنایع لاستیک؛
              مخترع فرمولاسیون های صنعتی، چسب لاستیک، صنایع لاستیک، سنگ‌های مصنوعی و سازنده‌ی انواع دستگاه‌های پیشرفته‌ی صنعتی
              سابقه بیش از ۷۰۰۰ ساعت تدریس در زمینه سنگ های کورین، کوارتز و مصنوعی، پتینه، نقاشی، خطاطی و ساخت ادوات موسیقی
              مولف کتاب های دانشگاهی و مقالات بین المللی
              طراح و مدرس ورکشاپ های آنلاین کارآفرینی
            </p>
          </div>
        </Container>
      </div>
    </>

  )
}
